import { inject, Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { zefGo, zefBack, zefForward } from './ngrx-router.action';

@Injectable()
export class NgrxRouterEffect {

  #router = inject(Router);
  #actions$ = inject(Actions);
  #location = inject(Location);

  onGo$ = createEffect(() => this.#actions$.pipe(
    ofType(zefGo),
    tap(({ path, query: queryParams, extras }) => {
      this.#router.navigate(
        path,
        {
          queryParams,
          ...extras
        }
      );
    })
  ), { dispatch: false });

  onBack$ = createEffect(() => this.#actions$.pipe(
    ofType(zefBack),
    tap(() => this.#location.back())
  ), { dispatch: false });

  onForward$ = createEffect(() => this.#actions$.pipe(
    ofType(zefForward),
    tap(() => this.#location.forward())
  ), { dispatch: false });

}
